import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gf-check-totals',
  template: `<div *ngIf="check" style="font-size: 18px;">
  <span class="label label-default" 
      [attr.title]="'Checks not applied' | translate">
      {{ totals[-1] }}
  </span>
  <span class="label label-success"
      [attr.title]="'Checks made, no warnings' | translate">
      {{ totals[0] }}
  </span>
  <span class="label label-warning" 
      [attr.title]="'Checks made with warning(s)' | translate">
      {{ totals[1] }}
  </span>
  <span class="label label-danger" 
      [attr.title]="'Checks made with failures' | translate">
      {{ totals[2] }}
  </span>
</div>
`
})
export class CheckTotalsComponent implements OnInit {
  @Input() check: any; // Specify the correct type instead of 'any' if known

  totals: any;

  ngOnInit(): void {
    this.totals = [-1, 0, 1, 2].reduce((carry, key) => {
      const val = this.check.totals[key];
      carry[key] = val ? val : 0;
      return carry;
    }, {});
  }
}
